/* eslint-disable complexity */
/* eslint-disable sort-keys */
/* eslint-disable max-lines */
import {
    DEFAULT_HEADER_HEIGHT, EmbedHeader,
} from './components/EmbedHeader/EmbedHeader'

import {
    EmbedQuestionnaire,
    QuestionnaireParams, QuestionnaireState,
    coreName,
} from './EmbedQuestionnaire'

import {
    HeroBellSolidIcon, XIcon,
} from 'components/Icon'

import {
    NinchatErrorEvent, NinchatQueueFoundEvent,
} from 'api/types/events'

import {
    NinchatMessages, NinchatProperties,
} from 'api/types'


import React, {
    useContext, useEffect,
} from 'react'

import {
    Route, RouteParamsList,
} from 'navigation/types'

import {
    embedComponentsWrapper, embedGlobalStyles,
    embedWrapper,
    embedWrapperInner,
    jitsiWrapper,
    newMessages,
    newMessagesButton,
    newMessagesCloseButton,
} from './styles'

import {
    isEqual, isPropsObjectEqual,
} from 'utils/props'

import {
    jitsiHangup, jitsiToggleChat,
} from 'actions/jitsi'

import {
    useAppDispatch, useAppSelector,
} from 'hooks'

import {
    useChannelDetails, useUsers,
} from 'hooks/ninchat'

import {EmbedChannel} from './EmbedChannel'
import EmbedConfirmationPromiseModal from './Modal/EmbedConfirmationPromiseModal'
import {EmbedContext} from 'components/EmbedContext'

import {
    EmbedEvent,
} from 'embed/types/events'

import {EmbedHome} from './EmbedHome'

import {EmbedQueue} from './EmbedQueue'
import {EmbedStorage} from './types'

import Jitsi from 'components/Jitsi'
import LightBox from 'components/LightBox'
import Login from 'components/Login'

import {QueueRoute} from 'embed/types/routes'

import ReactMarkdown from 'react-markdown'

import {closeSession} from 'api/action/closeSession'
import {config} from 'embed/listeners'
import {deleteUser} from 'api/action/deleteUser'
import {describeQueue} from 'api/action/describeQueue'
import {describeRealmQueues} from 'api/action/describeRealmQueues'

import {engine} from 'store/storage/engine'

import {markdownProps} from './helpers/markdown'
import {name} from '../../../app.json'
import {partChannel} from 'api/action/partChannel'
import {registerAudience} from 'api/action/registerAudience'
import {sendMessage} from 'api/action/sendMessage'
import {storageKey} from 'store/storage'
import {styled} from 'stitches/config'
import {updateUser} from 'api/action/updateUser'
import useLightbox from 'hooks/lightbox'
import {usePromiseModal} from 'components/Modal/PromiseModal/hooks/usePromiseModal'
import {useRouting} from 'navigation/hooks'
import {useSendToParent} from 'embed/utils/event'
import {useTranslation} from 'react-i18next'

const EmbedWrapper = styled('div', embedWrapper)
const EmbedWrapperInner = styled('div', embedWrapperInner)
const EmbedComponentsWrapper = styled('div', embedComponentsWrapper)
const JitsiWrapper = styled('div', jitsiWrapper)
const StyledNewMessages = styled('div', newMessages)
const StyledNewMessagesButton = styled('button', newMessagesButton)
const StyledNewMessagesCloseButton = styled('button', newMessagesCloseButton)

export const EmbedNavigation = () => {
    const embed = useContext(EmbedContext)
    const hasSession = useAppSelector(({ninchat}) => !!ninchat.session_id)
    const sessionId = useAppSelector(({ninchat}) => ninchat.session_id)
    const userId = useAppSelector(({ninchat}) => ninchat.user_id)
    const userSso = useAppSelector((state) => state.ninchat.user_sso)

    const dispatch = useAppDispatch()
    const navigationState = useAppSelector(({navigation: nav}) => nav)
    const targetOrigin = config.get('targetOrigin') || ''
    const openEmbedConfirmationModal = usePromiseModal(EmbedConfirmationPromiseModal)
    // eslint-disable-next-line prefer-destructuring
    const user = useUsers([userId || ''])[userId || '']
    const [embedReadyToFullyLoad, setEmbedReadyToFullyLoad] = React.useState(false)

    const {
        close: closeLightbox,
        isOpen: lightboxIsOpen,
    } = useLightbox()

    const {t} = useTranslation()
    const sendToParent = useSendToParent()
    const [questionnaireState, setQuestionnaireState] = React.useState<QuestionnaireState>({})
    const [audienceQuestionnaireDefaultState, setAudienceQuestionnaireDefaultState] = React.useState<QuestionnaireState | null>(null)
    const [postaudienceQuestionnaireDefaultState, setPostaudienceQuestionnaireDefaultState] = React.useState<QuestionnaireState | null>(null)
    const [skipNewMessages, setSkipNewMessages] = React.useState(false)

    const {
        position, routes,
    } = navigationState
    const route = position < routes.length ? routes[position] : routes[routes.length - 1]
    const defaultRoute: Route = {name: 'EmbedHome'}

    const persist = !!embed?.remember
    const sessionKey = embed?.sessionKey || ''

    const storageKeyEmbed = `${name}-embed${sessionKey ? `-${sessionKey}` : ''}`
    const storageKeyMain = storageKey

    const {pushRoute} = useRouting()

    const {
        isJitsiActive,
        activeVideoChannelId,
        videoConferenceJoined,
    } = useAppSelector(({jitsi}) => ({
        activeVideoChannelId: jitsi.activeVideoChannelId,
        isJitsiActive: jitsi?.isActive ?? false,
        videoConferenceJoined: jitsi.videoConferenceJoined ?? false,
    }), isPropsObjectEqual)

    const channelDetails = useChannelDetails({channelId: activeVideoChannelId})
    const channelMessages = useAppSelector(({ninchat}) => ninchat._messages[activeVideoChannelId]?.messages)

    const clearEmbedData = (clearData?: boolean) => {
        engine.removeItem(storageKeyEmbed)
        engine.removeItem(storageKeyMain)

        sendToParent({
            event: EmbedEvent.EmbedClose,
            targetOrigin,
            clearData,
        })

        sendToParent({
            event: EmbedEvent.Close,
            targetOrigin,
        })

        dispatch(closeSession())
    }

    const resetEmbed = (clearData?: boolean) => {
        embed?.setEmbedState((prevState) => ({
            ...prevState,
            lightBox: {
                imageAttr: null,
                imageSrc: null,
                open: false,
                options: {downloadDisabled: false},
            },
            error: null,
        }))
        setEmbedReadyToFullyLoad(false)
        pushRoute({name: 'EmbedHome'})

        setAudienceQuestionnaireDefaultState({})
        setPostaudienceQuestionnaireDefaultState({})

        if (user?.user_attrs?.guest) {
            dispatch(deleteUser({})).unwrap()
                .then(() => {
                    clearEmbedData(clearData)
                })
                .catch(() => {
                    clearEmbedData(clearData)
                })
        } else {
            clearEmbedData(clearData)
        }
    }

    const closeEmbed = (clearData?: boolean) => {
        if (route?.name === 'EmbedChannel') {
            if (embed?.embedState.lastChannelId) {
                dispatch(partChannel({channel_id: embed?.embedState.lastChannelId})).unwrap()
                    .then(() => {
                        resetEmbed(clearData)
                    })
                    .catch(() => {
                        resetEmbed(true)
                    })
            } else {
                resetEmbed(clearData)
            }
        } else {
            resetEmbed(clearData)
        }
    }

    const showEmbedClosingModal = (clearData?: boolean) => {
        const askAboutClosing = embed?.showCloseConfirmation === undefined ? true : embed?.showCloseConfirmation
        if (askAboutClosing) {
            let closeText = embed?.closeConfirmText || t('Closing window ends ongoing conversation.')
            let closeTitle = embed?.closeConfirmTitle || t('Sure you want to leave?')

            if (route?.name === 'EmbedQuestionnaire' || route?.name === 'EmbedPostQuestionnaire') {
                closeText = embed?.closeConfirmQuestionnaireText || t('You have filled the questionnaire. Closing window removes all entries.')
                closeTitle = embed?.closeConfirmQuestionnaireTitle || t('Sure you want to leave?')
            } else if (route?.name === 'EmbedQueue') {
                closeText = embed?.closeConfirmQueueText || t('This will end your chat session and chat will close. Do you want to continue?')
                closeTitle = embed?.closeConfirmQueueTitle || t('Leave queue?')
            }

            const text = () => (
                <ReactMarkdown {...markdownProps}>
                    {closeText || ''}
                </ReactMarkdown>
            )

            openEmbedConfirmationModal(
                {
                    text: text(),
                    title: closeTitle,
                    submitText: t('Yes, close chat'),
                    cancelText: t('Return to chat'),
                },
            )
                .then(() => {
                    closeEmbed(clearData)
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                }, () => {
                    sendToParent({
                        event: EmbedEvent.EmbedCloseCancelled,
                        targetOrigin,
                    })
                })
        } else {
            closeEmbed(clearData)
        }
    }

    const handleCloseEmbedLogic = (clearData?: boolean) => {
        if (lightboxIsOpen) {
            closeLightbox()
            return
        }

        if (route && route.name === 'EmbedQuestionnaire') {
            const isQreEdited = questionnaireState.buttonInteraction ||
                Object.keys(questionnaireState.formState || {}).length > 0


            if (isQreEdited) {
                showEmbedClosingModal(clearData)
            } else {
                closeEmbed(clearData)
            }
        } else if (route && route.name === 'EmbedPostQuestionnaire') {
            const isQreEdited = questionnaireState.buttonInteraction ||
                // eslint-disable-next-line no-extra-parens
                (Object.keys(questionnaireState.formState || {}).length > 0 && !isEqual(questionnaireState.formState, postaudienceQuestionnaireDefaultState?.formState))

            if (isQreEdited) {
                showEmbedClosingModal(clearData)
            } else {
                closeEmbed(clearData)
            }
        } else if (route && route.name === 'EmbedQueue') {
            showEmbedClosingModal(clearData)
        } else if (route && route.name === 'EmbedChannel') {
            if (embed?.postAudienceQuestionnaire) {
                dispatch(jitsiHangup())
                pushRoute({name: 'EmbedPostQuestionnaire'})
            } else {
                showEmbedClosingModal(clearData)
            }
        } else {
            closeEmbed(clearData)
        }
    }

    useEffect(() => {
        if (embed?.closeEmbedRef) {
            embed.closeEmbedRef.current = handleCloseEmbedLogic
        }
    })

    const questionnaireCompleteLogic = async ({
        queueId,
        metadata,
        resolve,
        userName,
        fileIds,
    }: {
        queueId: string,
        metadata: QueueRoute['params']['metadata'],
        resolve: ({queueClosed}: {queueClosed: boolean}) => void,
        userName?: string,
        fileIds?: Array<NinchatProperties.FileID>,
    }) => {
        try {
            if (userName) {
                if (Object.keys(userSso || {}).length === 0) {
                    await dispatch(updateUser({user_attrs: {name: userName}})).unwrap()
                }
            }
            const queueData = await dispatch(describeQueue({queue_id: queueId})).unwrap() as NinchatQueueFoundEvent
            const queueClosed = !!queueData?.queue_attrs?.closed

            if (queueClosed) {
                resolve({queueClosed})
            } else {
                resolve({queueClosed})
                pushRoute({
                    name: 'EmbedQueue',
                    params: {
                        fileIds,
                        metadata,
                        queue_id: queueId,
                    },
                })
            }
        } catch (error) {
            let title = t('Error describing queue')
            // eslint-disable-next-line no-extra-parens
            if ((error as NinchatErrorEvent)?.error_type === 'permission_denied') {
                title = t('Session expired')
            }

            embed?.setEmbedState((prevState) => ({
                ...prevState,
                error: {
                    message: t('We encountered an error. Please close and restart chat to continue.'),
                    title,
                },
            }))
        }
    }

    const handleQuestionnaireComplete = ({
        queueId, metadata, userName, fileIds,
    }: QuestionnaireParams) => new Promise<{queueClosed?: boolean}>((resolve) => {
        // without setTimeout there is strange error:
        // Cannot update a component (`EmbedNavigation`) while rendering a different component (`EmbedQuestionnaire`)
        // set timeout 0 is stacking pushRoute action as a last thing to do making sure previous component stopped rendering
        setTimeout(() => {
            questionnaireCompleteLogic({
                fileIds,
                queueId,
                metadata,
                resolve,
                userName,
            })
        }, 0)
    })

    const handleQuestionnaireRegister = ({
        queueId, metadata, fileIds,
    }: QuestionnaireParams) => dispatch(registerAudience({
        queue_id: queueId,
        audience_metadata: metadata as NinchatProperties.NinchatAudienceMetadata,
        file_ids: fileIds,
    }))
        .unwrap()
        .then(() => {
            sendToParent({
                event: EmbedEvent.AudienceRegistered,
                queue_id: queueId,
                targetOrigin,
            })
        })

    const handlePostQuestionnaireComplete = async ({
        metadata, rating,
    }: QuestionnaireParams) => {
        try {
            if (rating) {
                await dispatch(sendMessage({
                    channel_id: embed?.embedState.lastChannelId,
                    message_fold: true,
                    message_privileged: true,
                    message_recipient_ids: [userId || ''],
                    message_type: NinchatMessages.NinchatMessageTypes.NinchatMetadataMessage,
                    payload: [JSON.stringify({data: {rating}})],
                }))
            }

            const payload = {data: metadata || {}}
            if (payload.data.post_answers && Object.keys(payload.data.post_answers).length > 0) {
                await dispatch(sendMessage({
                    channel_id: embed?.embedState.lastChannelId,
                    message_fold: true,
                    message_privileged: true,
                    message_recipient_ids: [userId || ''],
                    message_type: NinchatMessages.NinchatMessageTypes.NinchatMetadataMessage,
                    payload: [JSON.stringify(payload)],
                }))
            }
        } catch (error) {
            let title = t('Error sending post questionnaire')
            // eslint-disable-next-line no-extra-parens
            if ((error as NinchatErrorEvent)?.error_type === 'permission_denied') {
                title = t('Session expired')
            }

            embed?.setEmbedState((prevState) => ({
                ...prevState,
                error: {
                    message: t('We encountered an error. Please close and restart chat to continue.'),
                    title,
                },
            }))
        }

        return new Promise<{queueClosed?: boolean}>((resolve) => {
            resolve({})
        })
    }

    const handleSaveQuestionnaireState = (state: QuestionnaireState) => {
        setQuestionnaireState(state)
        const currentState = engine.getItem(storageKeyEmbed)[persist ? 1 : 0] || {} as EmbedStorage

        engine.setItem(storageKeyEmbed, {
            ...currentState,
            questionnaire: state,
        }, persist)

        if (route?.name === 'EmbedQuestionnaire') {
            // initial state with formState only for post audience questionnaire
            setPostaudienceQuestionnaireDefaultState({
                buttonInteraction: false,
                currentStep: 0,
                stepsHistory: [0],
                stepsAnswersHistory: {},
                formState: state.formState,
                selectedQueueId: state.selectedQueueId,
            })
        }
    }

    const backToChat = () => {
        pushRoute({
            name: 'EmbedChannel',
            params: {channel_id: embed?.embedState.lastChannelId || ''},
        })
    }

    useEffect(() => {
        embedGlobalStyles(embed?.theme || {})
    }, [])

    useEffect(() => {
        if (hasSession) {
            // eslint-disable-next-line no-extra-parens
            const {
                route: lastRoute, ui,
            } = engine.getItem(storageKeyEmbed)[persist ? 1 : 0] as EmbedStorage || {}


            if (lastRoute) {
                if (lastRoute.name === 'EmbedChannel') {
                    sendToParent({
                        // eslint-disable-next-line no-extra-parens
                        channel_id: (lastRoute.params as RouteParamsList['EmbedChannel']).channel_id,
                        event: EmbedEvent.AudienceResumed,
                        targetOrigin,
                    })
                }
                pushRoute(lastRoute as Route)
            } else if (embed?.audienceAutoQueue && ui?.openState !== 'minimized') {
                pushRoute({
                    name: 'EmbedQueue',
                    params: {queue_id: embed.audienceAutoQueue},
                })
            } else {
                pushRoute(defaultRoute)
            }
        }
    }, [sessionId, hasSession, embed?.audienceRealmId])

    useEffect(() => {
        const currentState = engine.getItem(storageKeyEmbed)[persist ? 1 : 0] as EmbedStorage

        const mute = currentState?.ui?.mute ?? embed?.muteSounds ?? true

        sendToParent({
            event: EmbedEvent.EmbedUI,
            targetOrigin,
            ui: {
                ...currentState?.ui,
                mute,
            },
        })

        embed?.setEmbedState((prevState) => ({
            ...prevState,
            ...currentState?.embedState,
            mute,
        }))

        // if state was already set to some value or initial state was not minimized
        // eslint-disable-next-line no-extra-parens
        if (!embed?.floating || (embed?.floating && (currentState?.ui?.openState || embed?.floatingOptions?.initialState !== 'minimized'))) {
            setEmbedReadyToFullyLoad(true)
        }

        let questionnaire = currentState?.questionnaire || {}

        const metadataItems = Object.entries(embed?.audienceMetadata || {})
        const formStateFromMetadata: any = {}
        if (metadataItems.length > 0) {
            metadataItems.forEach(([key, value]) => {
                formStateFromMetadata[`${coreName}-${key}`] = {
                    _isAudienceMetadata: true,
                    value,
                    questionnaireType: 'preAudienceQuestionnaire',
                }
            })
        }

        questionnaire = {
            ...questionnaire,
            formState: {
                ...formStateFromMetadata,
                ...questionnaire.formState,
            },
        }

        setAudienceQuestionnaireDefaultState(questionnaire)
        setPostaudienceQuestionnaireDefaultState(questionnaire)
    }, [])

    useEffect(() => {
        if (embed?.audienceRealmId && hasSession) {
            dispatch(describeRealmQueues({realm_id: embed.audienceRealmId})).unwrap()
                .catch((error) => {
                    let title = t('Error describing realm queues')
                    // eslint-disable-next-line no-extra-parens
                    if ((error as NinchatErrorEvent)?.error_type === 'permission_denied') {
                        title = t('Session expired')
                    }

                    embed?.setEmbedState((prevState) => ({
                        ...prevState,
                        error: {
                            message: t('We encountered an error. Please close and restart chat to continue.'),
                            title,
                        },
                    }))
                })
        }
    }, [sessionId, hasSession, embed?.audienceRealmId])

    useEffect(() => {
        const currentItem = (engine.getItem(storageKeyEmbed)[persist ? 1 : 0] || {}) as EmbedStorage

        if (route?.name && route.name !== 'EmbedLogin') {
            // saving last embed route in local/session storage, skipping login route

            engine.setItem(storageKeyEmbed, {
                ...currentItem,
                route,
            }, persist)
        }

        if (route?.name === 'EmbedChannel') {
            // eslint-disable-next-line no-extra-parens
            const channelId = (route?.params as RouteParamsList['EmbedChannel']).channel_id
            const messageToSend = currentItem?.questionnaire?.selectedMessage
            const messageSend = currentItem?.questionnaire?.messageSend

            if (channelId) {
                if (messageToSend && !messageSend) {
                    dispatch(sendMessage({
                        channel_id: channelId,
                        message_type: NinchatMessages.NinchatMessageTypes.NinchatTextMessage,
                        payload: [JSON.stringify({text: messageToSend.trim()})],
                    })).then(() => {
                        engine.setItem(storageKeyEmbed, {
                            ...currentItem,
                            route,
                            questionnaire: {
                                ...currentItem.questionnaire,
                                messageSend: true,
                            },
                        }, persist)
                    })
                }
            }
        }
    }, [route])

    const toggleAbsoluteHero = () => {
        embed?.setEmbedState((prevState) => ({
            ...prevState,
            heroFullAbsoluteVisible: !prevState.heroFullAbsoluteVisible,
        }))
    }

    const onMessage = (message: MessageEvent<any>) => {
        if (message.origin === targetOrigin) {
            const {data} = message
            const {
                event, ui, clearData,
            } = data

            if (event === EmbedEvent.EmbedUI) {
                const currentItem = (engine.getItem(storageKeyEmbed)[persist ? 1 : 0] || {}) as EmbedStorage

                engine.setItem(storageKeyEmbed, {
                    ...currentItem,
                    ui,
                }, persist)

                if (ui?.openState !== 'minimized') {
                    setEmbedReadyToFullyLoad(true)
                }
            } else if (event === EmbedEvent.EmbedClose) {
                if (clearData) {
                    closeEmbed(clearData)
                    return
                }

                handleCloseEmbedLogic()
            } else if (event === EmbedEvent.EmbedHero) {
                toggleAbsoluteHero()
            }
        }
    }

    const onKeyDown = (e: KeyboardEvent) => {
        switch (e.key) {
            case 'Escape':
                sendToParent({
                    event: EmbedEvent.EmbedEscape,
                    targetOrigin,
                })
                break
            default:
                break
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', onKeyDown, false)
        window.addEventListener('message', onMessage, false)
        return () => {
            window.removeEventListener('message', onMessage)
            window.removeEventListener('keydown', onKeyDown)
        }
    }, [pushRoute])

    useEffect(() => {
        setSkipNewMessages(false)
    }, [channelDetails?.channelStatus, channelMessages?.length])


    // keep channelMembers in memory for situation when agents will close conversation
    useEffect(() => {
        const currentItem = (engine.getItem(storageKeyEmbed)[persist ? 1 : 0] || {}) as EmbedStorage

        const allChannelMembers = embed?.embedState?.channelMembersAll || []
        embed?.embedState?.channelMembers?.forEach((member) => {
            const existingMember = allChannelMembers.find((m) => m.id === member.id)
            if (!existingMember) {
                allChannelMembers.push(member)
            }
        })

        engine.setItem(storageKeyEmbed, {
            ...currentItem,
            embedState: {
                ...currentItem.embedState,
                channelMembers: embed?.embedState.channelMembers,
                allChannelMembers,
            },
        }, persist)
    }, [JSON.stringify(embed?.embedState.channelMembers)])

    const renderComponent = () => {
        switch (route?.name) {
            case 'EmbedHome':
                return <EmbedHome />
            case 'EmbedQueue':
                return (
                    <EmbedQueue
                        // eslint-disable-next-line no-extra-parens
                        fileIds={(route?.params as RouteParamsList['EmbedQueue'])?.fileIds || []}
                        // eslint-disable-next-line no-extra-parens
                        metadata={(route?.params as RouteParamsList['EmbedQueue'])?.metadata || ''}
                        // eslint-disable-next-line no-extra-parens
                        queueId={(route?.params as RouteParamsList['EmbedQueue'])?.queue_id || ''}
                        resetEmbed={resetEmbed}
                    />
                )
            case 'EmbedChannel':
                // eslint-disable-next-line no-extra-parens
                return <EmbedChannel channelId={(route.params as RouteParamsList['EmbedChannel'])?.channel_id || ''} resetEmbed={resetEmbed} />
            case 'EmbedQuestionnaire':
                // eslint-disable-next-line no-extra-parens
                return audienceQuestionnaireDefaultState ?
                    (
                        <EmbedQuestionnaire
                            closeEmbed={closeEmbed}
                            defaultQuestionnaireState={audienceQuestionnaireDefaultState}
                            onQuestionnaireComplete={handleQuestionnaireComplete}
                            onQuestionnaireRegister={handleQuestionnaireRegister}
                            resetEmbed={resetEmbed}
                            saveQuestionnaireState={handleSaveQuestionnaireState}
                        />
                    )
                    : null
            case 'EmbedPostQuestionnaire':
                // eslint-disable-next-line no-extra-parens
                return postaudienceQuestionnaireDefaultState ?
                    (
                        <EmbedQuestionnaire
                            backToChat={backToChat}
                            closeEmbed={closeEmbed}
                            defaultQuestionnaireState={postaudienceQuestionnaireDefaultState}
                            onQuestionnaireComplete={handlePostQuestionnaireComplete}
                            resetEmbed={resetEmbed}
                            saveQuestionnaireState={handleSaveQuestionnaireState}
                            type='postAudienceQuestionnaire'
                        />
                    )
                    : null
            case 'EmbedLogin':
            default:
                return (
                    <Login
                        params={{}}
                        resetEmbed={resetEmbed}
                    />
                )
        }
    }


    if (!embedReadyToFullyLoad) {
        return null
    }

    if (!hasSession && route?.name !== 'EmbedLogin') {
        // if there is no session or error, redirect to login
        pushRoute({name: 'EmbedLogin'})
    }

    const isContainerWithHeader = !embed?.floating && embed?.containerOptions?.showHeader
    const isChannel = route?.name === 'EmbedChannel'
    const isQueue = route?.name === 'EmbedQueue'

    return (
        <EmbedWrapper>
            {isContainerWithHeader ?
                // eslint-disable-next-line no-extra-parens
                <EmbedHeader channelId={(route?.params as RouteParamsList['EmbedChannel'])?.channel_id || ''} closeEmbed={() => handleCloseEmbedLogic(true)} routeName={route?.name || ''} />
                : null}
            <EmbedWrapperInner>
                {!!isJitsiActive &&
                <JitsiWrapper
                    css={
                        {$$headerHeight: `${embed?.containerOptions?.headerOptions?.height || DEFAULT_HEADER_HEIGHT}px`}
                    }
                    isContainerWithHeader={isContainerWithHeader}
                >
                    <Jitsi channel_id={activeVideoChannelId as string} />
                    {videoConferenceJoined && channelDetails.channelStatus === 'highlight' && !skipNewMessages ?
                        <StyledNewMessages>
                            <StyledNewMessagesButton onClick={() => dispatch(jitsiToggleChat())}>
                                <div><HeroBellSolidIcon /></div>
                                <div>{t('New messages in chat')}</div>
                                <div>
                                    <StyledNewMessagesCloseButton
                                        onClick={(ev) => {
                                            ev.stopPropagation()
                                            setSkipNewMessages(true)
                                        }}
                                        type='button'
                                    >
                                        <XIcon />
                                    </StyledNewMessagesCloseButton>
                                </div>
                            </StyledNewMessagesButton>
                        </StyledNewMessages>
                        : null}
                </JitsiWrapper>}
                <EmbedComponentsWrapper
                    css={
                        {$$headerHeight: `${embed?.containerOptions?.headerOptions?.height || DEFAULT_HEADER_HEIGHT}px`}
                    }
                    isChannel={isChannel}
                    isContainerWithHeader={isContainerWithHeader}
                    isQueue={isQueue}
                >
                    {renderComponent()}
                </EmbedComponentsWrapper>
            </EmbedWrapperInner>
            <LightBox />
        </EmbedWrapper>
    )
}
